import { Routes } from '@shared/constants/routes';
import { Text } from '@shared/ui/antd';
import { Button, Flex } from 'antd';
import { type ErrorResponse, useRouteError } from 'react-router';
import styles from './error.module.scss';
import { useTranslation } from 'react-i18next';

export const ErrorPage = () => {
  const { t } = useTranslation('translation');
  const error = useRouteError() as ErrorResponse;

  const handleNavigateToPrimaryPage = () => {
    if (typeof window !== 'undefined') {
      window.location.assign(Routes.analytics.root);
    }
  };

  return (
    <Flex align="center" justify="center" className={styles.root}>
      <Flex vertical gap={12} align="center" justify="center" className={styles.container}>
        <Text variant="5xl" fontWeight={700}>
          {t('common.errorPage.title')}
        </Text>

        <Text variant="md" fontWeight={500}>
          {t('common.errorPage.subtitle')}
        </Text>

        <Text variant="md" fontWeight={500}>
          {error?.statusText || error?.data}
        </Text>

        <Button type="primary" onClick={handleNavigateToPrimaryPage}>
          {t('common.errorPage.back')}
        </Button>
      </Flex>
    </Flex>
  );
};
